import * as Numerical from './numerical'
import * as Conceptual from './conceptual'

export default {
  Numerical,
  Conceptual,
}
